import React from 'react';
import { COMPONENT_TYPES, ELEMENT_TYPES } from '../config/constants';
import { FlexWrapper, Skeleton, Spinner } from '@intigral/shared';

export default ({ componentName, dataStream }) => {
    switch (componentName) {
        case COMPONENT_TYPES.FEATURED_SLIDER:
            return <Spinner />;
        case COMPONENT_TYPES.VOD_FEATURED_CAROUSEL:
            return (
                <div className="featured-content-small_loader">
                    <div className="card">
                        <div className="pre" />
                    </div>
                    <div className="card">
                        <div className="pre" />
                    </div>
                </div>
            );
        case COMPONENT_TYPES.VOD_CAROUSEL:
            return (
                <section className="content-loader_main">
                    {/* <h2 className="section-title">&nbsp;</h2> */}
                    <div className="trending-section_loader">
                        <div className="card">
                            <div className="pre" />
                        </div>
                        <div className="card">
                            <div className="pre" />
                        </div>
                        <div className="card">
                            <div className="pre" />
                        </div>
                        <div className="card">
                            <div className="pre" />
                        </div>
                        <div className="card">
                            <div className="pre" />
                        </div>
                        <div className="card">
                            <div className="pre" />
                        </div>
                    </div>
                </section>
            );
        case COMPONENT_TYPES.USER_WATCHLIST:
            return (
                <>
                    <div className="movies-section search-section detail-page_loader">
                        <div className="movies-section-main">
                            <h4 className="movies-section-title">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                            </h4>
                        </div>
                    </div>
                    <section className="watchlist-container masonry-loader">
                        <div className="my-masonry-grid">
                            <div className="my-masonry-grid_column colOne">
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colTwo">
                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="movie-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colThree">
                                <div className="movie-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colFour">
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colFive">
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colSix">
                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="movie-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            );
        case COMPONENT_TYPES.SEARCH_RESULTS:
            return (
                <>
                    <div className="movies-section search-section detail-page_loader">
                        <div className="movies-section-main">
                            <h4 className="movies-section-title">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                            </h4>
                            <div className="movies-types-dropdown">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="watchlist-container masonry-loader">
                        <div className="my-masonry-grid">
                            <div className="my-masonry-grid_column colOne">
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colTwo">
                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="movie-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colThree">
                                <div className="movie-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colFour">
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colFive">
                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-masonry-grid_column colSix">
                                <div className="cast-card masonry-item">
                                    <div className="cast-photo">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="eps-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>

                                <div className="movie-card masonry-item">
                                    <div className="poster-container">
                                        <div className="card">
                                            <div className="pre" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            );
        case COMPONENT_TYPES.REWIND_LIST:
        case COMPONENT_TYPES.STREAMING_CAROUSEL:
            return (
                <section className="detail-page-rewind">
                    <div className="RewindList-row-loader">
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                    </div>
                    <div className="RewindList-row-loader">
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                        <div className="rewind-card ">
                            <div className="pre" />
                        </div>
                    </div>
                </section>
            );
        case COMPONENT_TYPES.FULLVOD_CATALOG_LIST:
            return (
                <section className="detail-page-videosList">
                    <div className="videoList-main">
                        <div className="trending-section_loader" style={{ margin: '0' }}>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            {dataStream !== 'think_analytics_more_like_this' &&
                            dataStream !== 'think_analytics_custom_endpoint' ? (
                                <>
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                    <div className="videoList-main">
                        <div className="trending-section_loader" style={{ margin: '0' }}>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            <div className="card">
                                <div className="pre" />
                            </div>
                            {dataStream !== 'think_analytics_more_like_this' &&
                            dataStream !== 'think_analytics_custom_endpoint' ? (
                                <>
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                    {dataStream !== 'think_analytics_more_like_this' &&
                    dataStream !== 'think_analytics_custom_endpoint' ? (
                        <div className="videoList-main">
                            <div className="trending-section_loader" style={{ margin: '0' }}>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                            </div>
                        </div>
                    ) : null}
                </section>
            );
        case COMPONENT_TYPES.REWIND_CAROUSEL:
        case COMPONENT_TYPES.WATCHLIST_CAROUSEL:
        case COMPONENT_TYPES.CONTINIE_WATCHING:
            return (
                <div className="Continue-watch-gallery_loader">
                    <div className="card">
                        <div className="pre" />
                    </div>
                    <div className="card">
                        <div className="pre" />
                    </div>
                    <div className="card">
                        <div className="pre" />
                    </div>
                    <div className="card">
                        <div className="pre" />
                    </div>
                </div>
            );
        case COMPONENT_TYPES.TV_GUIDE_CAROUSEL:
            return (
                <div className="mini-epg mini-epg-loading">
                    <Skeleton />
                    <br />
                    <Skeleton style={{ height: '550px' }} />
                </div>
            );
        case COMPONENT_TYPES.DETAILS_CONTAINER:
            return (
                <div className="on-demand-copy">
                    <div className="movie-img">
                        <div className="card">
                            <div className="pre" />
                        </div>
                    </div>

                    <h3 className="detail-title">
                        <div className="card">
                            <div className="pre" />
                        </div>
                    </h3>
                    <div className="movie-rating-main">
                        <div className="card">
                            <div className="pre" />
                        </div>
                    </div>
                    <div className="poster-btns">
                        <div className="card">
                            <div className="pre" />
                        </div>
                        <div className="card">
                            <div className="pre" />
                        </div>
                        <div className="card">
                            <div className="pre" />
                        </div>
                    </div>
                    <div className="movie-synopsis">
                        <div className="card">
                            <div className="pre" />
                        </div>
                    </div>
                    <div className="movie-details">
                        <ul className="movie-detailsList">
                            <li>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                            </li>
                            <li>
                                <div className="card">
                                    <div className="pre" />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            );
        case COMPONENT_TYPES.CAST_CREW:
            return (
                <section className="cast-list">
                    <h2 className="section-title">
                        <div className="card">
                            <div className="pre" />
                        </div>
                    </h2>
                    <div className="cast-list-cont swiper-container swiper-container-initialized swiper-container-horizontal">
                        <div className="cast-list-main swiper-wrapper">
                            <div className="inner swiper-slide swiper-slide-active">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide swiper-slide-next">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="cast-photo">
                                    <div className="card">
                                        <div className="pre" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
                    </div>
                </section>
            );
        case COMPONENT_TYPES.SEASON_EPISODES:
            return (
                <>
                    <div className="Seasons">
                        <div className="card" />
                    </div>
                </>
            );
        case COMPONENT_TYPES.EPISODES:
            return (
                <section className="tv-show-section">
                    <div className="swiper-container tv-show-slider swiper-container-initialized swiper-container-horizontal">
                        <div className="swiper-wrapper tv-show-slider-gallery">
                            <div className="inner swiper-slide swiper-slide-active">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <h6>&nbsp;</h6>
                                <p>&nbsp;</p>
                            </div>
                            <div className="inner swiper-slide swiper-slide-next">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <h6>&nbsp;</h6>
                                <p>&nbsp;</p>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <h6>&nbsp;</h6>
                                <p>&nbsp;</p>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <h6>&nbsp;</h6>
                                <p>&nbsp;</p>
                            </div>
                            <div className="inner swiper-slide">
                                <div className="card">
                                    <div className="pre" />
                                </div>
                                <h6 className="pre">&nbsp;</h6>
                                <p className="pre">&nbsp;</p>
                            </div>
                        </div>
                        <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
                    </div>
                </section>
            );
        case ELEMENT_TYPES.EPISODE_LOADER:
            return (
                <div className="loader-container" style={{ opacity: 0.8 }}>
                    <div className="loader">
                        <svg className="spinner" viewBox="0 0 50 50">
                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
                        </svg>
                    </div>
                </div>
            );
        default:
            return (
                <div style={{ zIndex: '12', position: 'fixed', inset: '0' }}>
                    <Skeleton animation />
                    <Spinner />
                </div>
            );
    }
};
